import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { WaybillIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentWaybillTrackingState } from './shipment-waybill-tracking.state';
import { Observable } from 'rxjs';
import {
  ShipmentWaybillTrackingSetInitialState,
  ShipmentWaybillTrackingLoad,
} from './shipment-waybill-tracking.actions';
import { ShipmentWaybillMilestoneModel } from '../../models';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillTrackingFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillTrackingState.getLoaded);
  milestones$: Observable<ShipmentWaybillMilestoneModel[]> = this.store.select(
    ShipmentWaybillTrackingState.getMilestones,
  );
  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillTrackingLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillTrackingSetInitialState());
  }
}
